import PropTypes from 'prop-types'
import React from 'react'
import { getAdThumbnailUrl } from 'SRC/modules/ads/shared/functions'
import { Image as AdImage } from '../Image'
import { Banner } from '../Banner'
import { Carousel } from 'react-responsive-carousel'

export const Images = ({ad, onClick, length}) => {
  const [selectedItem, setSelectedItem] = React.useState(0)

  React.useEffect(() => {
    setSelectedItem(0)
  }, [ad.id])

  if (!ad || !Array.isArray(ad.media)) return null

  const main = ad.media ? ad.media.find(m => m.main) : null
  const img = getAdThumbnailUrl({ image: main, size: '600x450' })

  return (
    <div className='oglasi-imgs'>
      <Carousel
        showThumbs={false}
        selectedItem={selectedItem}
        onChange={itemIndex => { setSelectedItem(itemIndex) }}
        showIndicators={false}
        statusFormatter={(current, total) => `${current} od ${total}` }
        onClickItem={itemIndex => onClick(itemIndex)}
        interval={3000000}
      >
        <AdImage key='main-img' className='oglasi-item-tekst-img' img={img} title={ad.titleCompiled} />

        {ad.media.filter(m => !m.main && m.visible).map(imageItem => (
          <AdImage
            key={`image-${imageItem.id}`}
            className='oglasi-item-tekst-img'
            title={ad.titleCompiled}
            img={getAdThumbnailUrl({ image: imageItem, size: '600x450' })}
          />
        ))}

        <div key='banner' style={{ height: '100%' }}>
          {selectedItem === length ? <Banner key='banner' /> : null}
        </div>
      </Carousel>

      <div className='ukupno-slika'>
        <p>{length + 1}</p>
        <i className='ico-tab-fotografije ico' />
      </div>

      {ad.status === 'Sold' ? <div className='sold' /> : null}
    </div>
  )
}

Images.propTypes = {
  ad: PropTypes.object,
  onClick: PropTypes.func,
  length: PropTypes.number
}
